/**
Author - Babajan
Github - https://www.github.com/babajanpatan/
**/

import React from "react";
import SafeLink from "components/commons/SafeLink";
import Head from "next/head";

import GlobalStyle from "static/next/css/PartnerGlobalStyle";
import {WealthyEnv} from "helpers";
import {
  LogoWrapper,
  LogoImage,
  StaticWrapper,
  StaticContent,
  PageHeader,
  DividerLine,
  ContentSection
} from "components/StaticPages/Common";
import {NewFooter} from "components";

const CDN_URL = `${WealthyEnv.BROKING_COMPLIANCE_CDN_URL}/account-opening-process-`;

const AccountOpeningProcess = () => {
  return (
    <>
      <Head>
        <title>Account Opening Process | Wealthy</title>
        <meta
          content="Open your Wealthy investment account quickly and easily. Follow this simple step-by-step guide to complete KYC and start your wealth-building journey today."
          name="description"
        />
        <link href={`${WealthyEnv.URL}/account-opening-process`} rel="canonical" />
        <link href="https://i.wlycdn.com/wealthy-home-page/new-fav-icon.png" rel="icon" />
      </Head>
      <GlobalStyle />
      <LogoWrapper>
        <SafeLink href={WealthyEnv.URL}
           aria-label="Go to Wealthy home page"
        >
          <LogoImage
            alt="Wealthy Logo"
            src={`${WealthyEnv.HOMEPAGE_CDN_URL}/wealthy-new-purple-logo.svg`}
          />
        </SafeLink>
      </LogoWrapper>
      <main id="main-content">
      <StaticWrapper>
        <DividerLine />
        <PageHeader>
          Account Opening Process
        </PageHeader>
        <DividerLine />
        <StaticContent className='screenshots-wrapper'>

          <ContentSection>
            <p>
              One can open a demat account through online. Here, we have provided a step-by-step process of how to open a demat account for online processes.
            </p>
            <p>
              <span>Step 1: </span>Go to the Playstore then search <span>Wealthy app</span> and Install or Visit our website <SafeLink
                href={WealthyEnv.URL}
                rel="noopener noreferrer"
                target="_blank"
                aria-label="Visit Wealthy website (opens in new tab)"
              >
                 https://www.wealthy.in/
              </SafeLink> Under the header <span>“Let’s grow your wealth, together”</span> click on <span>“Get started”</span> and follow up the steps to complete the processes.
            </p>
            <img
              alt="Step 1: Wealthy app installation screen"
              loading="lazy"
              src={`${CDN_URL}step-1.jpeg`}
            />
            <img
              alt="Wealthy website account opening page"
              className="w-100"
              loading="lazy"
              src={`${CDN_URL}web-view.png`}
            />
            <h2>New Client Register</h2>
            <p><span>Step 2:</span> Click on Wealthy App and New Client register-Click on Sign up.</p>
            <img
             alt="New client registration screen in Wealthy app"
              loading="lazy"
              src={`${CDN_URL}step-2.jpeg`}
            />
            <p><span>Step 3:</span> Enter your mobile number, First name, Last name (optional) and invite code (Optional) to Register.</p>
            <img
              alt="Registration form with mobile number and name fields"
              loading="lazy"
              src={`${CDN_URL}step-3.jpeg`}
            />
            <p><span>Step 4:</span> Click on Get OTP and it will get capture and select the Object and verify.</p>
            <img
              alt="OTP verification and captcha validation screen"
              loading="lazy"
              src={`${CDN_URL}step-4.jpeg`}
            />
            <h2>Login Screen</h2>
            <p><span>Step 5:</span> It will get Login screen</p>
            <img
              alt="Wealthy app login screen"
              loading="lazy"
              src={`${CDN_URL}step-5.jpeg`}
            />
            <p><span>Step 6:</span> OTP will get normal message and WhatsApp number and enter the OTP.</p>
            <h2>Login PIN</h2>
            <p><span>Step 7:</span> Enter the 4 digits PIN.</p>
            <img
              alt="Create four digit login PIN screen"
              loading="lazy"
              src={`${CDN_URL}step-7.jpeg`}
            />
            <p><span>Step 8:</span> It will get two options</p>
            <ol>
              <li>Enable finger print</li>
              <li>No, l’ll do this later.</li>
            </ol>
            <p><span>Step 9:</span> Click on Enable Fingerprint and Get Popup and verify Fingerprint.</p>
            <h2>Dashboard</h2>
            <img
              alt="Wealthy app dashboard screen"
              loading="lazy"
              src={`${CDN_URL}step-9.jpeg`}
            />
            <p><span>Step 10:</span> Click on No I’ll do this later and it will go to the Homepage.</p>
            <img
              alt="Wealthy app homepage after login"
              loading="lazy"
              src={`${CDN_URL}step-10.jpeg`}
            />
            <p><span>Step 11:</span> Click on Wealth.</p>
            <img
              alt="Wealthy app navigation menu showing Home Watchlist Portfolio Orders and Wealthy"
              loading="lazy"
              src={`${CDN_URL}step-11.jpeg`}
            />
            <p>
              <span>1. Home</span><br />
              <span>2. Watch List</span><br />
              <span>3. Portfolio</span><br />
              <span>4. Orders</span><br />
              <span>5. Wealthy</span>
            </p>
            <h2>KYC Process</h2>
            <p><span>Step 12:</span> Display Start you KYC and Click on Begin KYC.</p>
            <p><span>Step 13:</span> Enter the mobile number and verify and Click on Continue.</p>
            <img
              alt="KYC mobile number verification screen"
              loading="lazy"
              src={`${CDN_URL}step-13.jpeg`}
            />
            <p><span>Step 14:</span> Enter the email id &gt; verify and Click on Continue.</p>
            <img
              alt="Email verification screen during KYC"
              loading="lazy"
              src={`${CDN_URL}step-14.jpeg`}
            />
            <h2>Personal Details</h2>
            <p><span>Step 15:</span> Enter your Personal Details PAN, Date of Birth and Down it will get three check boxes and read check and uncheck box and Click on Continue.</p>
            <img
              alt="Personal details form with PAN and date of birth fields"
              loading="lazy"
              src={`${CDN_URL}step-15.jpeg`}
            />
            <h2>DIGI Locker</h2>
            <p><span>Step 16:</span> Next step is DIGILOCKER and Click on Next button.</p>
            <img
              alt="DigiLocker integration step"
              loading="lazy"
              src={`${CDN_URL}step-16.jpeg`}
            />
            <h2>Upload Proofs-PAN-IDCARD</h2>
            <p><span>Step 17:</span> Start KYC Process-We have to upload documents</p>
            <ol>
              <li>Proof Of Identity-Clear image of Pan</li>
              <li>Proof Of Address-Clear image of ID Card</li>
              <li>Proof Of Identity-Clear image of PAN</li>
            </ol>
            <p>Click on Process</p>
            <img
              alt="Document upload screen for PAN and address proof"
              loading="lazy"
              src={`${CDN_URL}step-17.jpeg`}
            />
            <p><span>Step 18:</span> It will display Aadhaar number, DOB, Name and Click on check box and Click on Authenticate Aadhaar.</p>
            <img
              alt="Aadhaar authentication consent screen"
              loading="lazy"
              src={`${CDN_URL}step-18.jpeg`}
            />
            <p><span>Step 19:</span> Enter the Aadhaar Number and Enter the Capture -Letters and Numbers and Click on Next button.</p>
            <img
              alt="Aadhaar number entry and captcha verification screen"
              loading="lazy"
              src={`${CDN_URL}step-19.jpeg`}
            />
            <p><span>Step 20:</span> OTP is generated and Enter the OTP, Click on Continue.</p>
            <img
              alt="Aadhaar OTP verification screen"
              loading="lazy"
              src={`${CDN_URL}step-20.jpeg`}
            />
            <p><span>Step 21:</span> Allow Digiotech Solutions private limited.</p>
            <img
              alt="DigiLocker permission approval screen"
              loading="lazy"
              src={`${CDN_URL}step-21.jpeg`}
            />
            <p><span>Step 22:</span> DIGI KYC Process completed.</p>
            <img
              alt="DigiLocker KYC completion screen"
              loading="lazy"
              src={`${CDN_URL}step-22.jpeg`}
            />
            <h2>Other Mandatory Details</h2>
            <p>Enter the Father Name and Mother Name and Click on continue.</p>
            <img
              alt="Additional mandatory details form with parent information"
              loading="lazy"
              src={`${CDN_URL}step-22-b.jpeg`}
            />
            <p><span>Step 23:</span> Add Gender, occupations, Income.</p>
            <h2>Bank Details</h2>
            <p><span>Step 24:</span> Enter the Account number and IFSC code and Click on confirm.</p>
            <img
              alt="Bank account details form with account number and IFSC code"
              loading="lazy"
              src={`${CDN_URL}step-24.jpeg`}
            />
            <h2>Nominee Details</h2>
            <p><span>Step 25:</span> Enter the Nominee Detail -Full Name, DOB, PAN NO, Relation and enter the confirm.</p>
            <img
              alt="Nominee details form"
              loading="lazy"
              src={`${CDN_URL}step-25.jpeg`}
            />
            <h2>E-Sign</h2>
            <p><span>Step 26:</span> e-sign and Click on next.</p>
            <img
              alt="Electronic signature initiation screen"
              loading="lazy"
              src={`${CDN_URL}step-26.jpeg`}
            />
            <p>Signature for KYC and Click on Submit.</p>
            <img
              alt="Signature submission screen for KYC"
              loading="lazy"
              src={`${CDN_URL}step-26-b.jpeg`}
            />
            <h2>E-Selfie</h2>
            <p><span>Step 27:</span> Next step is IPV and Click on next.</p>
            <img
              alt="IPV verification step"
              loading="lazy"
              src={`${CDN_URL}step-27.jpeg`}
            />
            <p><span>Step 28:</span> Selfie for KYC</p>
            <img
              alt="Selfie capture screen for KYC verification"
              loading="lazy"
              src={`${CDN_URL}step-28.jpeg`}
            />
            <p><span>Step 29:</span> Click on terms conditions and two check boxes. Click on two check boxes and Click on proceed.</p>
            <img
              alt="Terms and conditions acceptance screen"
              loading="lazy"
              src={`${CDN_URL}step-29.jpeg`}
            />
            <p><span>Step 30:</span> Click on Account opening form and scroll down we can see all details for customer and Click on Sign now.</p>
            <img
              alt="Account opening form review and sign screen"
              loading="lazy"
              src={`${CDN_URL}step-30.jpeg`}
            />
            <p><span>Step 31:</span> Enter the Aadhaar number and Click on check box. Click on send OTP.</p>
            <img
              alt="Aadhaar eSign authentication screen"
              loading="lazy"
              src={`${CDN_URL}step-31.jpeg`}
            />
            <p><span>Step 32:</span> Enter the OTP and Click on Verify.</p>
            <img
              alt="OTP verification for eSign"
              loading="lazy"
              src={`${CDN_URL}step-32.jpeg`}
            />
            <p><span>Step 33:</span> Document submitted successfully and Click on Activate F & O.</p>
            <img
              alt="Document submission success screen"
              loading="lazy"
              src={`${CDN_URL}step-33.jpeg`}
            />
            <h2>KYC PROCESS Completed</h2>
            <p><span>Step 34:</span> Key process is completed and you will get message congratulations.</p>
            <img
              alt="KYC process completed successfully confirmation screen"
              loading="lazy"
              src={`${CDN_URL}step-34.jpg`}
            />
            <p>Once you have successfully completed the Account Opening process you can also track your application with status. It will take up to 2 working days to verify and activate your account.</p>
          </ContentSection>
        </StaticContent>
      </StaticWrapper>
      </main>
      <NewFooter />
    </>
  );
};

export default AccountOpeningProcess;
